import { Form, Input, Button, message } from 'antd'
import styles from './style.module.scss'
import { delTabsAction } from '../../modules/authtoken'
import { userRouter } from '../../route'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { UPDATEPASSWORD_API } from '../../api/CommonApi'
// 重置密码页
const Password = () => {
  const [form] = Form.useForm()
  const supRoute = userRouter[1].url
  const dispatch = useDispatch()
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const location = useLocation()
  const { pathname } = location
  function onFinish(e: any) {
    updatepassword({
      oldpassword: e.oldpassword,
      newpassword: e.newpassword,
    })
  }
  // 修改密码
  async function updatepassword(e: {
    oldpassword: string
    newpassword: string
  }) {
    const resData: any = await UPDATEPASSWORD_API({
      oldPassword: e.oldpassword,
      newPwd: e.newpassword,
    })
    if (resData.code === 0) {
      message.success('密码重置成功')
    } else {
      message.warning(resData.msg)
    }
  }
  const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 16 },
  }
  // 关闭
  const onCancel = () => {
    let newurl = ''
    if (tabsData.length === 1) {
      // 最后一个tabs
      newurl = `${supRoute}/home`
    }
    let delKey = ''
    if (tabsData.length > 1) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          param = index - 1
          delKey = item.key
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/home'
      newurl = `${url}`
    }
    // 删除标签 跳转前一个标签页
    dispatch(delTabsAction(delKey))

    history.replace(newurl)
  }
  return (
    <div className={styles.repassword}>
      <Form
        name="password"
        {...formItemLayout}
        form={form}
        onFinish={onFinish}
        style={{ width: 450 }}
      >
        <Form.Item
          label="输入旧密码"
          name="oldpassword"
          rules={[
            { required: true, message: '请输入旧密码', whitespace: true },
          ]}
        >
          <Input.Password inputPrefixCls="xh-input" placeholder="请输入" />
        </Form.Item>
        <Form.Item
          label="设置新密码"
          name="newpassword"
          rules={[
            { required: true, message: '请设置新密码', whitespace: true },
            {
              pattern: /^[\S]{6,16}$/,
              message:
                '新密码长度应在6-16位字符之间，建议使用数字、字母、符号的组合形式,请重新输入',
            },
          ]}
        >
          <Input.Password inputPrefixCls="xh-input" placeholder="请输入" />
        </Form.Item>
        <Form.Item
          label="确认新密码"
          name="newpasswords"
          rules={[
            { required: true, message: '请确认新密码', whitespace: true },
            {
              pattern: /^[\S]{6,16}$/,
              message: '两次密码不一致，请重新输入',
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue('newpassword') === value) {
                  return Promise.resolve()
                }
                return Promise.reject('两次密码不一致，请重新输入')
              },
            }),
          ]}
        >
          <Input.Password inputPrefixCls="xh-input" placeholder="请输入" />
        </Form.Item>
        <Form.Item noStyle>
          <div style={{ marginTop: 60, textAlign: 'center' }}>
            <Button
              type="default"
              htmlType="reset"
              onClick={onCancel}
              style={{ marginRight: 20 }}
            >
              关闭
            </Button>
            <Button type="primary" htmlType="submit">
              重置
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}

export default Password
import { Form, Input, Button, message } from 'antd'
import styles from './style.module.scss'
import { delTabsAction } from '../../modules/authtoken'
import { userRouter } from '../../route'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { UPDATEPASSWORD_API } from '../../api/CommonApi'
// 重置密码页
const Password = () => {
  const [form] = Form.useForm()
  const supRoute = userRouter[1].url
  const dispatch = useDispatch()
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const location = useLocation()
  const { pathname } = location
  function onFinish(e: any) {
    updatepassword({
      oldpassword: e.oldpassword,
      newpassword: e.newpassword,
    })
  }
  // 修改密码
  async function updatepassword(e: {
    oldpassword: string
    newpassword: string
  }) {
    const resData: any = await UPDATEPASSWORD_API({
      oldPassword: e.oldpassword,
      newPwd: e.newpassword,
    })
    if (resData.code === 0) {
      message.success('密码重置成功')
    } else {
      message.warning(resData.msg)
    }
  }
  const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 16 },
  }
  // 关闭
  const onCancel = () => {
    let newurl = ''
    if (tabsData.length === 1) {
      // 最后一个tabs
      newurl = `${supRoute}/home`
    }
    let delKey = ''
    if (tabsData.length > 1) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          param = index - 1
          delKey = item.key
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/home'
      newurl = `${url}`
    }
    // 删除标签 跳转前一个标签页
    dispatch(delTabsAction(delKey))

    history.replace(newurl)
  }
  return (
    <div className={styles.repassword}>
      <Form
        name="password"
        {...formItemLayout}
        form={form}
        onFinish={onFinish}
        style={{ width: 450 }}
      >
        <Form.Item
          label="输入旧密码"
          name="oldpassword"
          rules={[
            { required: true, message: '请输入旧密码', whitespace: true },
          ]}
        >
          <Input.Password inputPrefixCls="xh-input" placeholder="请输入" />
        </Form.Item>
        <Form.Item
          label="设置新密码"
          name="newpassword"
          rules={[
            { required: true, message: '请设置新密码', whitespace: true },
            {
              pattern: /^[\S]{6,16}$/,
              message:
                '新密码长度应在6-16位字符之间，建议使用数字、字母、符号的组合形式,请重新输入',
            },
          ]}
        >
          <Input.Password inputPrefixCls="xh-input" placeholder="请输入" />
        </Form.Item>
        <Form.Item
          label="确认新密码"
          name="newpasswords"
          rules={[
            { required: true, message: '请确认新密码', whitespace: true },
            {
              pattern: /^[\S]{6,16}$/,
              message: '两次密码不一致，请重新输入',
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue('newpassword') === value) {
                  return Promise.resolve()
                }
                return Promise.reject('两次密码不一致，请重新输入')
              },
            }),
          ]}
        >
          <Input.Password inputPrefixCls="xh-input" placeholder="请输入" />
        </Form.Item>
        <Form.Item noStyle>
          <div style={{ marginTop: 60, textAlign: 'center' }}>
            <Button
              type="default"
              htmlType="reset"
              onClick={onCancel}
              style={{ marginRight: 20 }}
            >
              关闭
            </Button>
            <Button type="primary" htmlType="submit">
              重置
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}

export default Password
